import { Tooltip } from 'antd';

import { AUTH_TYPES } from '@shared/pages/Login/constants';

import dayjs from 'dayjs';

import { ADD_REPEAT } from '@/constants/studyPlanStatus';

const MANAGER_ROLE_ID = 3;
const ADMIN_ROLE_ID = 2;
const SUPERADMIN_ROLE_ID = 1;
export default class Utils {
  static trString(str, len) {
    let sliced = str.slice(0, len);
    if (sliced.length < str.length) {
      sliced += '...';
    }

    return sliced;
  }

  static renderWithTooltip(str, len = 80) {
    if (len !== 0 && str?.length > len) {
      return <Tooltip title={str}>{this.trString(str, len)}</Tooltip>;
    } else {
      return str;
    }
  }

  static timezoneCounter(time, user) {
    return dayjs(time).add(user.timezone.offset / 60 - user.domainCompany.timezone.offset / 60, 'h');
  }

  static isAdmin(currentUser) {
    return (
      (currentUser?.parentRoleId && currentUser.parentRoleId === ADMIN_ROLE_ID) || currentUser.roleId === ADMIN_ROLE_ID
    );
  }

  static isSuperAdmin(currentUser) {
    return (
      (currentUser?.parentRoleId && currentUser.parentRoleId === SUPERADMIN_ROLE_ID) ||
      currentUser.roleId === SUPERADMIN_ROLE_ID
    );
  }

  static isAdminOrSuperAdmin(currentUser) {
    if (Utils.isAdmin(currentUser) || Utils.isSuperAdmin(currentUser)) {
      return true;
    }

    return false;
  }

  static isManager(currentUser) {
    return (
      (currentUser?.parentRoleId && currentUser.parentRoleId === MANAGER_ROLE_ID) ||
      currentUser.roleId === MANAGER_ROLE_ID
    );
  }

  static checkTitleAddToPlan(topic, translator) {
    if (topic?.userPlanType === ADD_REPEAT) {
      return 'retake';
    } else {
      return translator || 'planned';
    }
  }

  static isInternalProvider(currentUser) {
    if (
      currentUser.domainCompany.providers.find(provider => provider.type === AUTH_TYPES.INTERNAL && !provider.external)
    ) {
      return true;
    }

    return false;
  }

  static isMobileProvider(currentUser) {
    if (
      currentUser.domainCompany.providers.find(provider => provider.type === AUTH_TYPES.MOBILE && !provider.external)
    ) {
      return true;
    }

    return false;
  }

  static isOnline() {
    return window.navigator.onLine;
  }

  static capitalize(str) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1);
  }

  static checkDeadlineTrack = (selectedMonths, sections) => {
    const startDateString = selectedMonths.toString();
    const currentDay = dayjs();
    const selectedDate = dayjs(startDateString);
    const totalDuration = sections?.reduce((sum, item) => sum + item.duration, 0);

    const minDate = currentDay.add(totalDuration - 1, 'day'); // чтобы учесть сегодняшний день

    return selectedDate.isSame(minDate, 'day') || selectedDate.isAfter(minDate);
  };

  static getMinimumAllowedDate = trackSections => {
    const currentDay = dayjs();
    const totalDuration = trackSections?.reduce((sum, item) => sum + item.duration, 0);

    const minDate = currentDay.add(totalDuration - 1, 'day');

    return minDate;
  };
}
